import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';
import { invitesApi } from '@/lib/invitesApi';
import Navbar from '@/components/Navbar';

// Stable entry point for "Invitations" from the nav/search: spins up a fresh
// standalone event, then drops the user into its builder. (An event is required
// to hold the design + guests + entitlement.)
export default function InvitationsEntry() {
  const { user, token } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (user === null) { navigate('/auth?mode=register'); return; }
    if (!user) return; // still resolving auth
    let cancelled = false;
    invitesApi.createEvent({ source: 'standalone', title: `${user.name || 'My'}'s Event` }, token)
      .then((ev) => { if (!cancelled) navigate(`/events/${ev.event_id}/invitations`, { replace: true }); })
      .catch(() => { if (!cancelled) navigate('/'); });
    return () => { cancelled = true; };
  }, [user, token, navigate]);

  return (
    <div className="min-h-screen bg-background">
      <Navbar />
      <div className="max-w-md mx-auto py-24 text-center">
        <div className="w-8 h-8 border-2 border-primary border-t-transparent rounded-full animate-spin mx-auto mb-4" />
        <p className="text-sm text-muted-foreground">Setting up your invitation…</p>
      </div>
    </div>
  );
}
